import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import DataTable from 'react-data-table-component';
import { LuEye, LuTrash2, LuSearch, LuPencil, LuCopyCheck } from "react-icons/lu";
import { RoleForm } from "./manageRole";
import { IoCalendarOutline } from "react-icons/io5";
import masterApi from "../../../services/masterApi";
import { toast } from "react-toastify";
import { FunctionalityNames } from "../../../enum/enum";
import { getPermissionRights } from "../../../utils/common";
import { AuthContext } from "../../../context/AuthContext";



export default function RoleList({ setIsLoading }) {
    const REACT_APP_SEARCH_TEXT_LIMIT = process.env.REACT_APP_SEARCH_TEXT_LIMIT;

    const [isPopupupVisible, setIsPopupupVisible] = useState(false);
    const [roleList, setRoleList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(10);
    const [totalPages, setTotalPage] = useState(10);
    const [editRow, setEditRow] = useState(null);
    const [viewOnly, setViewOnly] = useState(null);
    const isCopy = useRef(false);
    const { rolePermissions } = useContext(AuthContext);
    const [userListPerm, setUserListPerm] = useState({});

    const columns = [
        {
            name: 'Name',
            width: "230px",
            selector: (row) => row.roleName
        },
        {
            name: 'Created On',
            width: "230px",

            selector: (row) => {
                const date = new Date(row.createdAt);
                return date.toLocaleDateString('en-GB'); // 'en-GB' formats as dd-mm-yyyy
            }
        },
        {
            name: 'Created by',
            width: "230px",
            selector: (row) => row.createdUserName
        },

        // {
        //     name: 'Email',
        //     selector: (row) => row.email
        // },
        // {
        //     name: 'Designation',
        //     selector: (row) => row.designation
        // },
        {
            name: "Action",
            width: "150px",
            sortable: false,
            button: true,
            right: true,
            // Add center alignment for header and cell
            center: true,
            cell: (row) => (
                <div className="gridIcons d-flex gap-2 justify-content-center align-items-center" data-tag="allowRowEvents">
                    {userListPerm?.create === 1 && (
                        <>
                            <button
                                type="button"
                                className="btn plain-btn-primary view-btn secondary-color"
                                title="Edit"
                                onClick={() => showeditPopup(row.id)}
                            >
                                <LuPencil />
                            </button>
                            <button
                                type="button"
                                className="btn plain-btn-primary view-btn secondary-color"
                                title="Copy rolls"
                                onClick={() => {
                                    isCopy.current = true;
                                    showviewPopup(row.id);
                                }}
                            >
                                <LuCopyCheck />
                            </button>
                        </>
                    )}
                    {userListPerm?.view === 1 && (
                        <button
                            type="button"
                            className="btn plain-btn-primary view-btn primary-color"
                            title="View"
                            onClick={() => showviewPopup(row.id)}
                        >
                            <LuEye />
                        </button>
                    )}
                </div>
            ),
        }
    ];

    // Add this useEffect if not present
    useEffect(() => {
        if (rolePermissions) {
            setUserListPerm(getPermissionRights(rolePermissions, FunctionalityNames.USERS));
        }
    }, [rolePermissions]);



    useEffect(() => {
        fetchData(currentPage, searchText);
    }, [rowsPerPage, isPopupupVisible]);

    const fetchData = async (page, searchtxt) => {
        setIsLoading(true);
        try {
            let queryString = `?pageIndex=${page}&pageLimit=${rowsPerPage}&searchText=${searchtxt}`;
            const response = await masterApi.getAllRoles(queryString)
            let roleList = response?.data?.roleList;
            setRoleList(roleList);
            let totalRecordsCount = roleList?.[0]?.totalRecords || 0;
            //alert(totalRecordsCount/rowsPerPage)
            setTotalRecords(totalRecordsCount);
            setTotalPage(Math.ceil(totalRecordsCount / rowsPerPage));
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && (searchText.trim().length >= REACT_APP_SEARCH_TEXT_LIMIT || searchText.trim().length == 0)) {
            fetchData(currentPage, searchText);
        }
    };
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchText(value);
        if (value.trim().length >= REACT_APP_SEARCH_TEXT_LIMIT || value.trim().length === 0) {
            fetchData(currentPage, value); // or just fetchData(value) if page doesn't matter
        }
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, searchText);
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setRowsPerPage(rowsPerPage);
        setCurrentPage(1); // Reset to page 1 when rows per page changes
        fetchData(currentPage, searchText);
    };

    const showeditPopup = (id) => {
        setEditRow(id);
        setViewOnly(false);
        setIsPopupupVisible(true);
    };
    const showviewPopup = (id) => {
        setEditRow(id);
        isCopy.current ? setViewOnly(false) : setViewOnly(true);
        setIsPopupupVisible(true);
    };
    const showPopup = () => {
        setEditRow(null);
        setViewOnly(false);
        setIsPopupupVisible(true);
    };
    const hidePopup = () => {
        setIsPopupupVisible(false);
        isCopy.current = false
    };
    const deleteRole = async (id) => {
        const response = await masterApi.deleteRole(id);
        console.log(response);
        if (response?.ok) {
            toast.success("Role deleted successfully", {
                position: "top-right",
                autoClose: 2000,
            });
            fetchData(currentPage, searchText);
        }
        else {
            toast.error("Role could not be deleted", {
                position: "top-right",
                autoClose: 2000,
            });
        }
    };
    return (
        <section>
            <section className="tool-bar d-flex align-items-center mb-3 gap-3">
                <div className="ms-auto position-absolute user-management-tool">
                    <div className="d-flex gap-2 align-items-center">
                        <div className="input-group search-container">
                            <input type="text" className="form-control" placeholder='Search' value={searchText}
                                onChange={handleInputChange} onKeyDown={handleKeyDown} />
                            <button type="button" className="btn plain-btn-secondary"><LuSearch /></button>
                        </div>
                        {userListPerm?.create === 1 && (
                            <button type="button" className="btn btn-primary d-flex" onClick={showPopup}>Create Role</button>
                        )}
                    </div>

                    {/* <div className="d-flex gap-2 align-items-center">
                        <div className="input-group search-container">
                            <input type="text" className="form-control" placeholder='Search' value={searchText}
                             onChange={handleInputChange} onKeyDown={handleKeyDown} />
                            {userListPerm?.create === 1 && (
                        <button type="button" className="btn btn-primary d-flex" onClick={showPopup}>Create Role</button>
                    )}
                        </div>
                        
                    </div> */}
                </div>
            </section>
            <section className="datatable-holder">
                <DataTable
                    columns={columns}
                    data={roleList}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRecords}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                //pagination
                />
            </section>
            {isPopupupVisible && <RoleForm closePopup={hidePopup} roleid={editRow} viewOnly={viewOnly} loadRoleList={fetchData} fromCopy={isCopy.current} />}
        </section>
    );
}
